// extracted by mini-css-extract-plugin
module.exports = {"toggleFollowingButton":"_2vEQpq","lightButton":"_1ql3XM","darkButton":"_4Ic38p","linkButton":"_1kw8AH"};